import { formatMoney } from '../../../lib/format';

/** 开户网上转账最低金额（身份核验） */
export const OPEN_ACCOUNT_TRANSFER = {
  minHkd: 10000,
  minUsd: 1500,
} as const;

/** 展示用千分位，无小数：10,000 */
export const formatTransferAmount = (n: number) => formatMoney(n, 0);
